import type { ReactElement } from 'react';

import { IconButton } from '../../../components/Button/IconButton';
import { Modal } from '../../../components/Modal';
import { NT_PURCHASE_PAGE_LINK } from '../../../domain/gainAccessView';
import { useNTStatusQuery } from '../../../features/user/useNTStatusQuery';
import { translate } from '../../../services/i18n';
import { ContactUsSuccessModal } from '../ContactUsSuccessModal/ContactUsSuccessModal';

import { useUpdatePackage } from './useUpdatePackage';

interface Props {
  onTrialButtonClick: () => void;
}

export const PackageUpgradeBlock = ({ onTrialButtonClick }: Props): ReactElement => {
  const { data: NTStatus } = useNTStatusQuery();
  const { isHookModalOpen, setIsHookModalOpen, onOpenModalAndSendContactUsRequest } = useUpdatePackage();

  const handleTrialButtonClick = () => {
    if (!NTStatus?.isAllowed) {
      onOpenModalAndSendContactUsRequest();
    }
    onTrialButtonClick();
  };

  return (
    <>
      <IconButton onClick={handleTrialButtonClick} iconName={'spark'} variant="flatTrial">
        {NTStatus?.isAllowed ? (
          <a href={NT_PURCHASE_PAGE_LINK} target="_blank" rel="noreferrer">
            {translate('upgrade.button')}
          </a>
        ) : (
          translate('upgrade.button')
        )}
      </IconButton>
      <Modal isOpen={isHookModalOpen} onClose={() => setIsHookModalOpen(false)}>
        <ContactUsSuccessModal />
      </Modal>
    </>
  );
};
